<template>
	<!-- v-for="filter in filterModel" :key="filter" -->
	<div class="chip_w" style="vertical-align: top">
		<v-row no-gutters>
			<v-col cols="auto pr-1">
				<span class="filter_name" ref="filterName" style="color: #292829; opacity: 0.45"> {{ filter.name }}: </span>
			</v-col>
			<v-col>
				<v-autocomplete
					v-if="filter.items"
					dense
					ref="ac"
					append-icon=""
					item-value="id"
					:item-text="filter.name == 'App' ? 'service_name' : 'name'"
					hide-details
					single-line
					:items="filter.items"
					v-model="filterValue"
					class="filter_ac"
					style="font-size: 14px; top: -5px"
					:style="{ width: inputWidth + 'px' }"
				>
				</v-autocomplete>
			</v-col>
			<v-col cols="auto">
				<v-btn icon x-small><v-icon style="font-size: 9px; color: #404d64 !important" @click="closeChip()">mdi-close</v-icon></v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	name: 'TaskLogListFilterChip',
	components: {},
	props: {
		filter: {
			type: Object,
		},
	},
	watch: {
		filter: {
			handler() {
				if (this.filter.items && this.filter.items.length > 0) {
					console.log('got items');

					setTimeout(() => {
						this.$refs.ac.focus();
						this.$refs.ac.isMenuActive = true;
					}, 100);
				}
			},
			immediate: true,
		},
		filterValue() {
			this.$emit('setFilterValue', this.filter, this.filterValue);
			const selectedItem = this.filter.items.find((item) => item.id === this.filterValue);
			this.filterText = selectedItem ? selectedItem.name : '';
		},
	},
	computed: {
		inputWidth() {
			return this.displayTextWidth(this.filterText, '14px proxima-nova');
		},
		acWidth() {
			return 60;
		},
	},
	methods: {
		displayTextWidth(text, font) {
			const canvas = this.displayTextWidth.canvas || (this.displayTextWidth.canvas = document.createElement('canvas'));
			const context = canvas.getContext('2d');
			context.font = font;
			const metrics = context.measureText(text);
			return metrics.width;
		},
		closeChip() {
			this.$emit('removeChip');
		},
		onFocus() {
			console.log('got focus');
		},
	},
	mounted() {
		// console.log("Text Width: " + this.displayTextWidth("This is demo text!", "italic 19pt verdana"));
		const autocompleteInput = this.$refs.ac.$refs.input;

		autocompleteInput.addEventListener('focus', this.onFocus, true);
	},
	data: () => ({
		filterValue: '',
		filterText: '',
	}),
};
</script>

<style scoped>
.chip_w {
	height: 25px;
	line-height: 25px;
	padding: 0px 10px;
	background: #eff1f7;
	border-radius: 13px;
	font-size: 14px !important;
	color: #292829;
	display: inline-block;
	text-align: left;
	padding-right: 15px;
	position: relative;
	vertical-align: middle;
}
.filter_ac {
	transition: all 0.2s ease-in-out;
	min-width: 30px;
}
</style>
